import React, { useEffect } from 'react';
import ProjectHero from '../components/projectpage/Hero';
import TabNavigation from '../components/projectpage/TabNavigation';
import LocationSection from '../components/projectpage/Location';
import LifestyleSection from '../components/projectpage/LifeStyle';
// import HousingOptions from '../components/projectpage/HousingOptions';
import AmenitiesSection from '../components/projectpage/Amenities';
import ServicesSection from '../components/projectpage/Services';
import FloorPlans from '../components/projectpage/FloorPlans';

import ProjectVideo from '../components/projectpage/ProjectVideo';

const ProjectPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <ProjectHero />
      <TabNavigation />
      <div id="location">
        <LocationSection />
      </div>
      <div id="lifestyle">
        <LifestyleSection />
      </div>
      <ProjectVideo />
      <div id="floorplans">
        <FloorPlans />
      </div>
      {/* <div id="housing">
        <HousingOptions />
      </div> */}
      <div id="amenities">
        <AmenitiesSection />
      </div>
      <div id="services">
        <ServicesSection />
      </div>
    </div>
  );
};

export default ProjectPage;